<template>
    <div class="security no-select">
        <van-nav-bar title="安全围栏" left-text="返回" fixed :border="false" left-arrow @click-left="backPage" />
        <div class="card">
            <img class="district-img" src="@/assets/images/tianjiashouhuquyu.png" background-size="cover"/>
        </div>
        <!-- <van-button class="com-btn-blue" plain type="info" @click="editFence(false)">添加危险区域</van-button> -->
        <div class="btn-box">
            <van-button round class="com-btn-blue" type="info" @click="editFence(false)">添加围栏区域</van-button>
        </div>
        <fence-list :data="fenceList" @edit="editFence" @remove="showDelFence"></fence-list>
    </div>
</template>

<script>
import FenceList from './components/fence-list.vue';
import { setTimeout } from 'timers';
export default {
    components: {
        FenceList
    },
    data() {
        return {
            // token: 'b9621ace07d592c9f0c17ccf3c12b55f', // token 测试时随便输入的, 之后换上正确的即可
            fenceList: [], // 围栏列表
            timeout: null,//计时器
        };
    },

    created() {
        this.getFence(); // 获取围栏列表
    },

    methods: {

        /**
         * 获取围栏列表
         */
        getFence() {
            let data = {
                ver: 1,
                method: 'getFenceList',
                page: 1,
                pageSize: 20
            };
            this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
                if (res.code === 0) {
                    this.fenceList = res.data.list || [];
                } else {
                    this.fenceList = [];
                }
            });
        },

        /**
         * 删除围栏
         * @param {Object} postData 请求参数
         */
        deleteFence(postData) {
            this.$http.post(this.$api.userInfo.POST_APPLET, postData).then(res => {
                if (res.code === 0) {
                    this.$toast({
                        message: '删除成功',
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/correct.png')
                    });
                    this.timeout = setTimeout(() => {
                        this.getFence(); // 获取围栏列表
                    }, 1000)

                }
            });
        },

        /**
         * 弹窗删除围栏确认框
         * @param {String} id 围栏id
         */
        showDelFence(id) {
            this.$dialog.confirm({
                title: '操作提示',
                message: '是否确认删除此围栏？'
            }).then(() => {
                let postData = {
                    ver: 1,
                    method: 'delFence',
                    fenceId: id
                };
                this.deleteFence(postData);
            });
        },

        /**
         * 编辑围栏
         * @param {Object} obj 当前围栏数据
         */
        editFence(obj) {
            if (obj) {
                this.$router.push({ name: 'addFence', query: { data: JSON.stringify(obj) } });
            } else {
                this.$router.push({ name: 'addFence' });
            }
        },

        backPage() {
            this.$router.push('/more');
        }
    },
    destroyed() {
        this.timeout = null;
    }
};
</script>

<style lang="scss" scoped>
// 蓝色按钮
.com-btn-blue {
    margin: 0 auto;
    border: none;
    width: 586px;
    height: 98px;
    background-color: #01ADA9;
}

.security {
    background-color: #f8f8f8;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 150px;
    // 卡片插画
    .district-img{
        width: 670px;
        height: 220px;
        margin: 120px 0 25px;
    }
    .btn-box{
    z-index: 9;
    position: fixed;
    width: 100%;
    padding: 20px 0 50px;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #f8f8f8;
    }
}
</style>
